import React from 'react';
import {
  space,
  width,
  height,
  position,
  top,
  right,
  bottom,
} from 'styled-system';
import { Text, Image } from 'rebass';
import { styled, Colors } from '../../themes';
import StarSVG from './star-1.svg';
import { Link } from 'components';
import { useTranslation } from 'react-i18next';

const TrustPilotBadge = () => {
  const [t] = useTranslation();
  return (
    <Container width={[140, null, null, 220]} height={[140, null, null, 220]}>
      <Star
        position="absolute"
        top={[18, null, null, 30]}
        width={[20, null, null, 30]}
        height={[20, null, null, 30]}
        src={StarSVG}
      />
      <Text fontSize={[2, null, null, 7]} fontWeight={700} color="white">
        TrustPilot score
      </Text>
      <Text
        lineHeight={[0.9]}
        fontSize={[12, null, null, 14]}
        fontWeight={700}
        color="white"
      >
        {t('trustpilot-badge.score')}
      </Text>
      <Text fontSize={[2, null, null, 7]} color="white">
        {t('trustpilot-badge.reviews', { count: 269 })}
      </Text>
      <Button
        position="absolute"
        right={0}
        bottom="-20px"
        width={[55, null, null, 70]}
        height={[55, null, null, 70]}
        target={'_blank'}
        to={'https://se.trustpilot.com/review/www.yepstr.com'}
      >
        <Text fontSize={[2, null, null, 6]} fontWeight={700} color="darkOrange">
          {t('trustpilot-badge.see-all-label')}
        </Text>
      </Button>
    </Container>
  );
};

const Container = styled.section`
  ${space}
  ${width}
  ${height}
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${Colors.greenish};
  box-shadow: 0 25px 50px 0 rgba(0, 108, 80, 0.4);
`;

const Star = styled(Image)`
  ${width}
  ${height}
  ${position}
  ${top}
`;

const Button = styled(Link)`
  ${width}
  ${height}
  ${position}
  ${right}
  ${bottom}
  border-radius: 50%;
  background-color: ${Colors.white};
  box-shadow: 0 20px 50px 0 rgba(43, 44, 61, 0.25);
  transition: box-shadow 0.2s ease;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    box-shadow: none;
  }

  &:active {
    opacity: 0.95;
  }
`;

export default TrustPilotBadge;
